import { classConstants, scheduleConstants } from '../../constants';
import { classService, scheduleService } from '../../services';
import { notificationActions } from './notification.actions';

const getAll = () => {
  return async (dispatch: any) => {
    const request = (scheduleObj: any) => {
      return { type: scheduleConstants.GETALL_REQUEST, payload: scheduleObj };
    };
    const success = (scheduleObj: any) => {
      return { type: scheduleConstants.GETALL_SUCCESS, payload: scheduleObj };
    };
    const failure = (scheduleObj: any) => {
      return { type: scheduleConstants.GETALL_FAILURE, payload: scheduleObj };
    };

    try {
      scheduleService.getAll().then(
        (schedules: any) => {
          dispatch(success(schedules));
        },
        (error: any) => {
          dispatch(failure(error.toString()));
          dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
        }
      );
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification('Error when GET_ALL_SCHEDULES!', 'DANGER'));
    }
  };
}

const createSchedule = ({ classId, schedules }: any) => {
  return (dispatch: any) => {
    dispatch(request({ classId, schedules }));

    scheduleService.create({ classId, schedules }).then(
      (scheduleObj: any) => {
        dispatch(success(scheduleObj));
        dispatch(notificationActions.addNotification('Tạo Lịch Học Thành Công!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request(scheduleObj: any) {
    return { type: scheduleConstants.CREATE_REQUEST, payload: scheduleObj };
  }
  function success(scheduleList: any) {
    // Hàm chuyển đổi 1 item trong B sang định dạng giống item của A
    const normalizeItem = (item: any) => {
      return {
        ...item,
        classId: Number(item.classId), // chuyển classId thành number
        startTime: item.startTime.length === 5 ? `${item.startTime}:00` : item.startTime,
        endTime: item.endTime.length === 5 ? `${item.endTime}:00` : item.endTime,
      };
    };
    return { type: scheduleConstants.CREATE_SUCCESS, payload: scheduleList.map(normalizeItem) };
  }
  function failure(error: any) {
    return { type: scheduleConstants.CREATE_FAILURE, error };
  }
};

const updateSchedule = ({ classId, schedules }: any) => {
  return (dispatch: any) => {
    dispatch(request({ classId, schedules }));

    scheduleService.update({ classId, schedules }).then(
      (scheduleObj: any) => {
        dispatch(success(scheduleObj));
        dispatch(notificationActions.addNotification('Cập nhật lịch học thành công!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request(scheduleObj: any) {
    return { type: scheduleConstants.UPDATE_REQUEST, payload: scheduleObj };
  }
  function success(scheduleList: any) {
    const normalizeItem = (item: any) => ({
      ...item,
      classId: Number(item.classId),
      startTime: item.startTime.length === 5 ? `${item.startTime}:00` : item.startTime,
      endTime: item.endTime.length === 5 ? `${item.endTime}:00` : item.endTime,
    });
    return { type: scheduleConstants.UPDATE_SUCCESS, payload: scheduleList.map(normalizeItem) };
  }
  function failure(error: any) {
    return { type: scheduleConstants.UPDATE_FAILURE, error };
  }
};

const deleteSchedule = (classId: any) => {
  return (dispatch: any) => {
    dispatch(request(classId));
    scheduleService.remove(classId).then(
      () => {
        dispatch(success(classId));
        dispatch(notificationActions.addNotification('Xoá Lịch Học Thành Công!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request(classId: number) {
    return { type: scheduleConstants.DELETE_REQUEST, payload: classId };
  }
  function success(deletedClassId: number) {
    return { type: scheduleConstants.DELETE_SUCCESS, payload: deletedClassId };
  }
  function failure(error: any) {
    return { type: scheduleConstants.DELETE_FAILURE, error };
  }
};

const updateClass = (formData: any) => {
  return (dispatch: any) => {
    dispatch(request(formData));

    classService.update(formData).then(
      (updatedClassObj: any) => {
        dispatch(success(updatedClassObj));
        dispatch(notificationActions.addNotification('Update Class Successfully!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request(updatingClassObj: any) {
    return { type: classConstants.UPDATE_REQUEST, payload: updatingClassObj };
  }
  function success(updatedClassObj: any) {
    return { type: classConstants.UPDATE_SUCCESS, payload: updatedClassObj };
  }
  function failure(error: any) {
    return { type: classConstants.UPDATE_FAILURE, error };
  }
};

export const scheduleActions = {
    getAll, 
    createSchedule,
  updateSchedule,
    deleteSchedule,
};
